// extracted by mini-css-extract-plugin
export var backgroundImage = "EduHeroSection-module--backgroundImage--ce033";
export var content = "EduHeroSection-module--content--41176";
export var intro = "EduHeroSection-module--intro--2deb7";
export var wrapper = "EduHeroSection-module--wrapper--d2bd5";